/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {getUserByToken} from '../core/_requests'
import {auth} from './firebase'
import {signInWithEmailAndPassword} from 'firebase/auth'
import {useAuth} from '../core/Auth'
import type {AuthError} from 'firebase/auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

const errorMessages: any = {
  'auth/invalid-credential': 'Invalid Email or Password.',
  'auth/user-not-found': 'No account found with this email.',
  'auth/invalid-email': 'Please enter a valid email address.',
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const userCredential = await signInWithEmailAndPassword(auth, values.email, values.password)
        const user = userCredential.user

        const idToken = await user.getIdToken()
        // const { data: auth } = await login(values.email, values.password)

        const {data: userData} = await getUserByToken(idToken)
        saveAuth(true)
        localStorage.setItem('userId', userData?.data?.id)
        setCurrentUser(userData?.data)
      } catch (error) {
        saveAuth(undefined)
        const err = error as AuthError
        // console.log(err.code)
        setStatus(errorMessages[err.code] || 'Something went wrong')
      } finally {
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Sign In to PickleBali</h1>
      </div>

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {'is-valid': formik.touched.email && !formik.errors.email}
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>

      <div className='fv-row mb-10 position-relative'>
        <label className='form-label fw-bolder text-dark fs-6'>Password</label>
        <input
          placeholder='Password'
          type={showPassword ? 'text' : 'password'}
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx('form-control form-control-lg form-control-solid')}
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{marginTop: '3.5px'}}
          className='position-absolute top-50 end-0  pe-3 cursor-pointer'
        >
          {showPassword ? (
            <i className='bi bi-eye fs-5'></i>
          ) : (
            <i className='bi bi-eye-slash fs-5'></i>
          )}
        </span>
        {/* {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )} */}
      </div>

      <div className='d-flex flex-end mb-4 mt-4'>
        {/* <Link
          to='/auth/forgot-password'
          className='link-primary fs-6 fw-bolder'
          style={{ marginLeft: '5px' }}
        >
          Forgot Password?
        </Link> */}
      </div>

      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Log In</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}
